import { getUTCDate } from '../../utilities/datetime'
import { eventTypes } from '../../utilities/eventTypes'

export const superFeedInitialState = {
  superFeedView: {
    list: ['list', 'grid'],
    currentView: 'list',
    default: 'list',
  },
  list: [],
  loading: false,
  isLastPage: false,
  totalSize: 0,
  pageNo: 1,
  maxPageNo: -1,
  pageSize: 20,
  filterBy: {
    "rrURLYN": "N",
    "incldFP": "N"
  },
  sortBy: [],
  params: {},
  screenshots: {},
  screenshotsLoading: {},
  selectedEvent: {},
  selectedEventLoading: false,
  markedScreenshots: {},
  markedScreenshotsLoading: {},
  html: {},
  // calculateTotal: true,
  htmlLoading: {},
}
